
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useScrollLock } from '../../../hooks/useScrollLock'
import { showModal } from '../../../features/modal/modalSlice'
import { getAdminUyeSuruculeri } from '../../../features/admin2/admin2Slice'
import Btn from '../../shared/button/Btn'
import PageTopTitle from '../../shared/PageTopTitle'
import styled from 'styled-components'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import UyeSuruculerContainer from '../../shared/adminUyelerAraclar/MobilUyeSuruculerContainer'

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1400px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 20px 0 20px;
            width: 90%;
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height: 600px;
            overflow: auto;

            .titles{
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                gap: 15px;
                text-align: center;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 30px;
            gap: 40px;
        }
    }
`

const titles = [
    "Adı Soyadı",
    "Cep Telefonu",
    "TC No",
    "Doğum Tarihi",
    "Adres",
    "Adres İl/ilçe",
    "Ehliyet",
    "SRC",
    "Belgeler",
]

const AdminUyeninSuruculerModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    
    const { lockScroll, unlockScroll } = useScrollLock();
    const {modalLocation } = useSelector(state => state.modal)
    const {uyeItemData, uyeSurucuList} = useSelector(state => state.admin2)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    

    useEffect(() => {
        dispatch(getAdminUyeSuruculeri({userId: uyeItemData.id}))
    },[])

  return (
    <ModalContainer>
    <div className="modal" onClick={() => dispatch(handleActiveSelect(null))}>
        <PageTopTitle title={"Üyenin Sürücüleri"}/>
        <div className="content">

            <div className="titles">
                {
                    titles.map((item) => (
                        <div>{item}</div>
                    ))
                }
            </div>
            {
                uyeSurucuList.map(item => (
                    <UyeSuruculerContainer data={item}/>
                ))
            }
        </div>

        <div className="button-grp">
            {/* <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{isLoadingUpdateAdminUye ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Güncelle"}</Btn> */}
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
        </div>
    </div>

</ModalContainer>
  )
}

export default AdminUyeninSuruculerModal